module.exports = __webpack_public_path__ + "static/media/map-music.d6c09117.png";